import ComponentCollectionService from 'packages/services/ComponentCollectionService';
import ComponentService, { PartialComponent } from 'packages/services/ComponentService';
import { EnrichedComponentCollection } from './types';

export const COLLECTIONS_PAGE_SIZE = 50;
export const COMPONENTS_PAGE_SIZE = 20;

export async function fetchCollections(
    page: number,
    searchValue: string,
): Promise<{ collections: EnrichedComponentCollection[]; hasMore: boolean } | null> {
    const response = await ComponentCollectionService.getComponentCollections({
        size: COLLECTIONS_PAGE_SIZE,
        page,
        presetSearch: '',
        sort: ['created', 'desc'],
    });

    if (response.status !== 200) {
        return null;
    }

    const collectionContent = response.json.content;

    const enrichedCollections = await Promise.all(
        collectionContent.map(async (collection) => {
            const componentsResponse = await ComponentService.getComponents({
                size: 4,
                page: 0,
                collectionId: collection.id,
                search: searchValue,
                sort: ['created', 'desc'],
            });

            if (componentsResponse.status !== 200) {
                return { ...collection, components: [] as PartialComponent[], totalComponents: 0 };
            }

            return {
                ...collection,
                components: componentsResponse.json.content,
                totalComponents: componentsResponse.json.totalElements,
            };
        }),
    );

    return { collections: enrichedCollections, hasMore: !response.json.last };
}

interface FetchComponentsParams {
    page: number;
    search: string;
    collectionId?: number;
}

export async function fetchComponents(
    params: FetchComponentsParams,
): Promise<{ components: PartialComponent[]; total: number; hasMore: boolean } | null> {
    const response = await ComponentService.getComponents({
        size: COMPONENTS_PAGE_SIZE,
        page: params.page,
        search: params.search,
        sort: ['created', 'desc'],
        ...(params.collectionId != null ? { collectionId: params.collectionId } : {}),
    });

    if (response.status !== 200) {
        return null;
    }

    return {
        components: response.json.content,
        total: response.json.totalElements,
        hasMore: !response.json.last,
    };
}
